import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Tag } from "antd"

import WYSIWYGEditor from "../../../../_shared/components/WYSIWYGEditor"
import useForm from "../../../../_shared/hooks/useForm.js"
import AppButton from "../../../../_shared/components/AppButton"

import UnderlinedInput from "./UnderlinedInput"
import ImageUploadInput from "./ImageUploadInput"

// ----------------------------------------------------------------------------

const POST_CATEGORIES = [
  "News",
  "Area tecnica",
  "Corsi di formazione",
  "Legislazione",
]

// ----------------------------------------------------------------------------

function PostForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { post, onCancel, onSubmit } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const formDefaultValues = post || {}

  const [formValues, setFormValue] = useForm(formDefaultValues)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleFormSubmit(event) {
    event.preventDefault()

    onSubmit && onSubmit(formValues)
  }

  function handlePostImageUpload(file) {
    setFormValue("image", file)
  }

  function handleEditorValueChange(htmlString) {
    setFormValue("body", htmlString)
  }

  function handleInputChange(key) {
    return function (event) {
      setFormValue(key, event.target.value)
    }
  }

  // -------------------------------------

  function renderPostCategoriesTags() {
    const tags = POST_CATEGORIES.map((category) => {
      const isSelected = formValues?.category === category

      return (
        <Tag
          className={`category-tag${isSelected ? " selected" : ""}`}
          key={category}
          onClick={() => setFormValue("category", category)}
        >
          {category}
        </Tag>
      )
    })

    return (
      <div className="category-select-container">
        <label>Categoria</label>

        <div className="tags-row">{tags}</div>
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const editorConfig = {
    charCounterCount: true,
  }

  return (
    <form className={props.className} onSubmit={handleFormSubmit}>
      <div className="values">
        {renderPostCategoriesTags()}
        {/* <UnderlinedInput */}
        {/*   className="input full-width" */}
        {/*   placeholder="Categoria" */}
        {/*   fontSize={16} */}
        {/*   fontWeight={400} */}
        {/*   value={formValues?.category} */}
        {/*   onChange={handleInputChange("category")} */}
        {/* /> */}

        <ImageUploadInput
          className="input full-width"
          onUpload={handlePostImageUpload}
          image={formValues?.image}
        />

        <UnderlinedInput
          className="input full-width"
          placeholder="Titolo"
          fontSize={32}
          fontWeight={600}
          value={formValues?.title}
          onChange={handleInputChange("title")}
        />

        <WYSIWYGEditor
          className="margin-top full-width"
          placeholder="Inserisci il testo del post..."
          value={formValues?.body}
          onChange={handleEditorValueChange}
        />

        <UnderlinedInput
          className="input full-width"
          placeholder="URL"
          fontSize={24}
          value={formValues?.link}
          onChange={handleInputChange("link")}
        />
      </div>

      <div className="actions">
        <AppButton
          className="spacer"
          uxType="ghosted"
          htmlType="button"
          onClick={onCancel}
        >
          Annulla
        </AppButton>
        <AppButton>Salva</AppButton>
      </div>
    </form>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

PostForm.propTypes = {
  className: PropTypes.string.isRequired,
  post: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
}

PostForm.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledPostForm = styled(PostForm)`
  & {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-height: 100%;

    .values {
      padding-bottom: 20px;
    }

    .category-select-container {
      margin-bottom: 10px;

      display: flex;
      flex-direction: column;

      > label {
        margin-bottom: 5px;
        font-weight: 600;
        color: ${(props) => props.theme.colors.placeholderColor};
      }

      .tags-row {
        display: flex;
        flex-direction: row;

        .category-tag {
          cursor: pointer;

          border-color: ${(props) => props.theme.colors.borderColor};
          background-color: transparent;
          color: ${(props) => props.theme.colors.borderColor};

          transition: all 0.2s ease-in-out;

          :hover {
            background-color: ${(props) =>
              props.theme.colors.primaryBackgroundColor};
          }

          &.selected {
            border-color: ${(props) => props.theme.colors.primaryColor};
            background-color: ${(props) => props.theme.colors.primaryColor};
            color: ${(props) => props.theme.colors.textOnPrimary};
          }
        }
      }
    }

    .input {
      margin-bottom: 30px;
    }

    .full-width {
      width: 100%;
    }

    .actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      .spacer {
        margin-right: 10px;
      }
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledPostForm
